import { mergeMap, catchError, filter, switchMap, take } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of, EMPTY, merge } from 'rxjs';
import * as Actions from './v3-opt-out.actions';
import { saveUserSetting, USER_SETTING_SAVE_REQUEST_SUCCESS } from '../../store/user/user.actions';
import { UserInterfaceService } from '../../services/user-interface-service';
import * as Api from './v3-opt-out.api';
import { isV2iframePath } from '../../global/splash/v2check';

export const redirectUserToV2 = (action$) => {
  return action$.pipe(
    ofType(Actions.SEND_USER_TO_V2),
    mergeMap(() => {
      const pathname = window.location.pathname;
      if (!isV2iframePath(pathname)) {
        UserInterfaceService.sendUserToV2();
      }
      return EMPTY;
    }),
    catchError(() => {
      return EMPTY;
    }),
  );
};

export const optOutWithoutFeedbackEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.V3_OPT_OUT_WITHOUT_FEEDBACK),
    mergeMap(() => {
      const userInterfacePreferenceSetting = {
        settingName: UserInterfaceService.getPreferredUiSettingName(),
        settingValue: 'V2',
        excludeV3prefix: true,
      };

      return Api.returnToV2().pipe(
        switchMap(() => {
          const redirectToV2 = true;
          return merge(
            of(saveUserSetting(userInterfacePreferenceSetting)),
            action$.pipe(
              ofType(USER_SETTING_SAVE_REQUEST_SUCCESS),
              filter((action) => {
                const setting = action.setting || {};
                return setting.settingName?.includes(UserInterfaceService.getPreferredUiSettingName());
              }),
              take(1),
              mergeMap(() => of(Actions.optOutWithoutFeedbackSuccess(redirectToV2), Actions.sendUserToV2())),
            ),
          );
        }),
        catchError((error) => of(Actions.optOutWithoutFeedbackFailure(error))),
      );
    }),
  );
};
